import DonutChart from './../App/DonutChart.js';

export default ($element) => {
    let Class = new DonutChart();
    Class.setData($element);

    Class.getChart();
    $element.addClass('initialized');
};
